import { z } from "zod";

const cloudflareAiErrorTypeValues = [
  "MISSING_CREDENTIALS",
  "REQUEST_FAILED",
  "REQUEST_UNREACHABLE",
  "INVALID_RESPONSE",
] as const;

const cloudflareAiErrorTypeSchema = z.enum(cloudflareAiErrorTypeValues);
const CloudflareAiErrorType = cloudflareAiErrorTypeSchema.enum;
type CloudflareAiErrorType = z.infer<typeof cloudflareAiErrorTypeSchema>;

interface ErrorDetails {
  sentryDescription: string;
}

export type CloudflareAiErrors =
  | {
      errorType: typeof CloudflareAiErrorType.MISSING_CREDENTIALS;
      data: Record<string, never>;
    }
  | {
      errorType: typeof CloudflareAiErrorType.REQUEST_FAILED;
      data: { model: string; status: number };
    }
  | {
      errorType: typeof CloudflareAiErrorType.REQUEST_UNREACHABLE;
      data: { model: string; isTimeout: boolean };
    }
  | {
      errorType: typeof CloudflareAiErrorType.INVALID_RESPONSE;
      data: { model: string };
    };

export const cloudflareAiErrorDetails: Record<CloudflareAiErrorType, ErrorDetails> = {
  [CloudflareAiErrorType.MISSING_CREDENTIALS]: {
    sentryDescription: "CLOUDFLARE_ACCOUNT_ID or CLOUDFLARE_AI_API_TOKEN is not configured in this environment",
  },
  [CloudflareAiErrorType.REQUEST_FAILED]: {
    sentryDescription: "Cloudflare Workers AI returned a non-success status",
  },
  [CloudflareAiErrorType.REQUEST_UNREACHABLE]: {
    sentryDescription: "Cloudflare Workers AI did not respond before the timeout or the connection failed",
  },
  [CloudflareAiErrorType.INVALID_RESPONSE]: {
    sentryDescription: "Cloudflare Workers AI returned a body that does not match the expected schema",
  },
};
